import styled from 'styled-components';

import { Icon } from '@/shared/ui/icon';

import { StyledOpen } from './navigation-accordion.types';

export const Arrow = styled(Icon)<StyledOpen>`
	transform: ${({ open }) => (open ? 'rotate(360deg)' : 'rotate(180deg)')};
`;
